import { render, staticRenderFns } from "./ClientRateView.vue?vue&type=template&id=9c18c4b8&"
import script from "./ClientRateView.vue?vue&type=script&lang=js&"
export * from "./ClientRateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports